var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_21940)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7496 44.8125H40.9996C40.2821 44.8125 39.6871 44.2175 39.6871 43.5C39.6871 42.7825 40.2821 42.1875 40.9996 42.1875H42.7496C43.9571 42.1875 44.9371 41.2075 44.9371 40V23.8125H30.4996C28.4346 23.8125 26.5446 24.9325 25.5296 26.735C25.1796 27.365 24.3746 27.5925 23.7446 27.2425C23.1146 26.8925 22.8871 26.0875 23.2371 25.4575C24.7071 22.8325 27.4896 21.1875 30.4996 21.1875H46.2496C46.9671 21.1875 47.5621 21.7825 47.5621 22.5V40C47.5621 42.66 45.4096 44.8125 42.7496 44.8125Z",
    fill: "url(#paint0_linear_19_21940)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.25 55.3125H51.5C50.7825 55.3125 50.1875 54.7175 50.1875 54C50.1875 52.7925 49.2075 51.8125 48 51.8125C46.7925 51.8125 45.8125 52.7925 45.8125 54C45.8125 54.7175 45.2175 55.3125 44.5 55.3125H37.5C36.7825 55.3125 36.1875 54.7175 36.1875 54C36.1875 52.7925 35.2075 51.8125 34 51.8125C32.7925 51.8125 31.8125 52.7925 31.8125 54C31.8125 54.7175 31.2175 55.3125 30.5 55.3125H28.75C25.1275 55.3125 22.1875 52.3725 22.1875 48.75C22.1875 48.0325 22.7825 47.4375 23.5 47.4375C24.2175 47.4375 24.8125 48.0325 24.8125 48.75C24.8125 50.92 26.58 52.6875 28.75 52.6875H29.3625C29.94 50.675 31.795 49.1875 34 49.1875C36.205 49.1875 38.06 50.675 38.6375 52.6875H43.38C43.9575 50.675 45.8125 49.1875 48.0175 49.1875C50.2225 49.1875 52.0775 50.675 52.655 52.6875H53.25C55.42 52.6875 57.1875 50.92 57.1875 48.75V44.8125H53.25C51.57 44.8125 50.1875 43.43 50.1875 41.75V36.5C50.1875 34.82 51.5525 33.4375 53.25 33.4375L51.3775 30.165C50.9925 29.4825 50.2575 29.0625 49.47 29.0625H47.5625V40C47.5625 42.66 45.41 44.8125 42.75 44.8125H41C40.2825 44.8125 39.6875 44.2175 39.6875 43.5C39.6875 42.7825 40.2825 42.1875 41 42.1875H42.75C43.9575 42.1875 44.9375 41.2075 44.9375 40V27.75C44.9375 27.0325 45.5325 26.4375 46.25 26.4375H49.47C51.2025 26.4375 52.795 27.365 53.6525 28.87L56.645 34.1025C56.8725 34.505 56.8725 35.0125 56.645 35.415C56.4175 35.8175 55.98 36.0625 55.5075 36.0625H53.25C53.005 36.0625 52.8125 36.255 52.8125 36.5V41.75C52.8125 41.995 53.005 42.1875 53.25 42.1875H58.5C59.2175 42.1875 59.8125 42.7825 59.8125 43.5V48.75C59.8125 52.3725 56.8725 55.3125 53.25 55.3125Z",
    fill: "url(#paint1_linear_19_21940)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 58.8125C31.34 58.8125 29.1875 56.66 29.1875 54C29.1875 51.34 31.34 49.1875 34 49.1875C36.66 49.1875 38.8125 51.34 38.8125 54C38.8125 56.66 36.66 58.8125 34 58.8125ZM34 51.8125C32.7925 51.8125 31.8125 52.7925 31.8125 54C31.8125 55.2075 32.7925 56.1875 34 56.1875C35.2075 56.1875 36.1875 55.2075 36.1875 54C36.1875 52.7925 35.2075 51.8125 34 51.8125Z",
    fill: "url(#paint2_linear_19_21940)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 58.8125C45.34 58.8125 43.1875 56.66 43.1875 54C43.1875 51.34 45.34 49.1875 48 49.1875C50.66 49.1875 52.8125 51.34 52.8125 54C52.8125 56.66 50.66 58.8125 48 58.8125ZM48 51.8125C46.7925 51.8125 45.8125 52.7925 45.8125 54C45.8125 55.2075 46.7925 56.1875 48 56.1875C49.2075 56.1875 50.1875 55.2075 50.1875 54C50.1875 52.7925 49.2075 51.8125 48 51.8125Z",
    fill: "url(#paint3_linear_19_21940)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 44.8125H53.25C51.57 44.8125 50.1875 43.43 50.1875 41.75V36.5C50.1875 34.82 51.57 33.4375 53.25 33.4375H55.5075C55.98 33.4375 56.4175 33.6825 56.645 34.1025L59.6375 39.3525C59.7425 39.545 59.8125 39.7725 59.8125 40V43.5C59.8125 44.2175 59.2175 44.8125 58.5 44.8125ZM53.25 36.0625C53.005 36.0625 52.8125 36.255 52.8125 36.5V41.75C52.8125 41.995 53.005 42.1875 53.25 42.1875H57.1875V40.35L54.7375 36.0625H53.25Z",
    fill: "url(#paint4_linear_19_21940)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 34.3125H23.5C22.7825 34.3125 22.1875 33.7175 22.1875 33C22.1875 32.2825 22.7825 31.6875 23.5 31.6875H34C34.7175 31.6875 35.3125 32.2825 35.3125 33C35.3125 33.7175 34.7175 34.3125 34 34.3125Z",
    fill: "url(#paint5_linear_19_21940)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 39.5625H23.5C22.7825 39.5625 22.1875 38.9675 22.1875 38.25C22.1875 37.5325 22.7825 36.9375 23.5 36.9375H30.5C31.2175 36.9375 31.8125 37.5325 31.8125 38.25C31.8125 38.9675 31.2175 39.5625 30.5 39.5625Z",
    fill: "url(#paint6_linear_19_21940)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 44.8125H23.5C22.7825 44.8125 22.1875 44.2175 22.1875 43.5C22.1875 42.7825 22.7825 42.1875 23.5 42.1875H27C27.7175 42.1875 28.3125 42.7825 28.3125 43.5C28.3125 44.2175 27.7175 44.8125 27 44.8125Z",
    fill: "url(#paint7_linear_19_21940)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_21940",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_21940"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_21940",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_21940",
    x1: 35.3174,
    y1: 21.1875,
    x2: 35.3174,
    y2: 44.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_21940",
    x1: 41,
    y1: 26.4375,
    x2: 41,
    y2: 55.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19_21940",
    x1: 34,
    y1: 49.1875,
    x2: 34,
    y2: 58.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19_21940",
    x1: 48,
    y1: 49.1875,
    x2: 48,
    y2: 58.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19_21940",
    x1: 55,
    y1: 33.4375,
    x2: 55,
    y2: 44.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19_21940",
    x1: 28.75,
    y1: 31.6875,
    x2: 28.75,
    y2: 34.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19_21940",
    x1: 27,
    y1: 36.9375,
    x2: 27,
    y2: 39.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19_21940",
    x1: 25.25,
    y1: 42.1875,
    x2: 25.25,
    y2: 44.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.ec3bde095cc082d71bc5d3d4d9cd2c62.svg";
export { ForwardRef as ReactComponent };